import { render, staticRenderFns } from "./ServiceConfig.vue?vue&type=template&id=accbeb4a&scoped=true"
import script from "./ServiceConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceConfig.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ServiceConfig.vue?vue&type=style&index=0&id=accbeb4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accbeb4a",
  null
  
)

export default component.exports